import React from "react";
import PropTypes from "prop-types";

import {Button, message} from "antd";
import {PlusOutlined} from "@ant-design/icons";
import DragDrop from "../dnd/DragDrop";
import OptionCard from "./OptionCard";
import EditFragment from "./EditFragment";
import ArrayUtil from "../../util/ArrayUtil";
import BaseUtil from "../../util/BaseUtil";

// custom form control
export default class OptionSort extends React.Component {
    static propTypes = {
        value: PropTypes.array, // [{id, name, disabled}]
        onChange: PropTypes.func,
        addButtonText: PropTypes.string, // 新增的文本
        onEditingChange: PropTypes.func, // 是否处于编辑状态的回调函数
    }

    static defaultProps = {
        onChange: () => {},
        addButtonText: "添加选项内容",
        onEditingChange: () => {},
    }

    constructor(props) {
        super(props);
        this.state = {
            isAdding: false,
            value: [],
            editingCount: 0, // 记录是否处于编辑状态
        };
    }

    componentWillUnmount() {
        this.props.onEditingChange(false);
    }

    changeEditingCount = (method) => {
        const {onEditingChange} = this.props;
        const prevValue = this.state.editingCount;
        let nextValue;
        if (method === "increment") {
            nextValue = prevValue + 1;
        } else if (method === "decrement") {
            nextValue = prevValue - 1;
        }
        this.setState({
            editingCount: nextValue,
        });
        if (prevValue === 0) {
            onEditingChange(true);
        } else if (nextValue === 0) {
            onEditingChange(false);
        }
    }
   
    validateName = (text) => {
        const {value} = this.props;
        const found = _.chain(value || this.state.value)
            .some(it => it.name === text)
            .value();
        return !found;
    }

    addNewItem = (text) => {
        const {value, onChange} = this.props;
        if (this.validateName(text)) {
            const newValue = _.chain(value || this.state.value)
                .concat({
                    isNew: true,
                    id: BaseUtil.uuid(),
                    name: text,
                })
                .value();
            this.setState({
                isAdding: false,
                value: newValue,
            });
            this.changeEditingCount("decrement");
            onChange(newValue);
        } else {
            message.error("名称重复。");
        }
    }

    onMove = (fromIndex, toIndex) => {
        const {value, onChange} = this.props;
        const newValue = ArrayUtil.move(value || this.state.value, fromIndex, toIndex);
        if (value == null) {
            this.setState({
                value: newValue,
            });
        }
        onChange(newValue);
    }

    onChangeName = (newName, record, setIsEditing) => {
        const {value, onChange} = this.props;
        if (this.validateName(newName) || newName === record.name) {
            const newValue = _.chain(value || this.state.value)
                .map((it) => {
                    return {
                        ...it,
                        name: record.id === it.id ? newName : it.name,
                    };
                })
                .value();
            this.setState({
                value: newValue,
            });
            this.changeEditingCount("decrement");
            setIsEditing(false);
            onChange(newValue);
        } else {
            message.error("名称重复。");
        }
    }

    onDelete = (record) => {
        const {value, onChange} = this.props;
        const newValue = _.chain(value || this.state.value)
            .filter(it => it.id !== record.id)
            .value();
        this.setState({
            value: newValue,
        });
        onChange(newValue);
    }

    render() {
        const {value, addButtonText, onChange} = this.props;

        return (
            <DragDrop.Container>
                <div
                    style={{
                        border: "1px solid #D2D8DE",
                        borderRadius: 5,
                    }}
                >
                    {
                        _.map(value || this.state.value, (it, index) => {
                            return (
                                <OptionCard
                                    key={it.id}
                                    data={it}
                                    index={index}
                                    onMove={this.onMove}
                                    onChangeName={this.onChangeName}
                                    onDelete={this.onDelete}
                                    changeEditingCount={this.changeEditingCount}
                                />
                            );
                        })
                    }
                    {
                        this.state.isAdding
                            ? (
                                <div style={{display: "flex", height: 44, alignItems: "center", paddingLeft: 8}}>
                                    <EditFragment
                                        onCancel={() => {
                                            this.setState({
                                                isAdding: false,
                                            });
                                            this.changeEditingCount("decrement");
                                        }}
                                        onCommit={this.addNewItem}
                                    />
                                </div>
                            )
                            : (
                                <Button
                                    onClick={() => {
                                        this.setState({
                                            isAdding: true,
                                        });
                                        this.changeEditingCount("increment");
                                    }}
                                    type="link"
                                    style={{
                                        width: "100%",
                                        height: 40,
                                        borderWidth: 0,
                                        borderRadius: "0 0 5px 5px",
                                        backgroundColor: "rgba(0, 132, 255, .1)",
                                    }}
                                >
                                    <PlusOutlined />
                                    {addButtonText}
                                </Button>
                            )
                    }
                </div>
            </DragDrop.Container>
        );
    }
}
